export const INVALID_VALIDATION_LINK = 'invalid_validation_link';
